export default {
  clientSettings: "Systeem instellingen",
  logout: "Uitloggen",
  showHelp: "Laat hulp zien"
}
